import dayjs from 'dayjs';

/**
 * This function is provisionally configured to meet the needs of KLM.
 * @param {string} formatted date formatted
 * @param {date} date Date to replace
 */
const formatDate = (formattedDate: string, date: string) => {
  return formattedDate.replace(/[2-9]{1}[0-9]{3}/g, () => {
    return `${dayjs(date).format('YYYY')}`;
  });
};

// FIXME: This function mutates the fare item passed as a parameter. Use with caution.
export function yearAdjustmentPatch(
  fareItem: Pick<
    FareItem,
    'departureDate' | 'returnDate' | 'formattedDepartureDate' | 'formattedReturnDate'
  >,
  uiDatesYearsAdjustmentPatch: number
) {
  if (uiDatesYearsAdjustmentPatch) {
    // TODO: Adjusting the date for the case in which the airlines
    // want to show a data of the future as if it were of the present
    // const { datePattern } = query;
    if (uiDatesYearsAdjustmentPatch < 0) {
      fareItem.departureDate =
        fareItem.departureDate &&
        dayjs(fareItem.departureDate)
          .subtract(uiDatesYearsAdjustmentPatch * -1, 'year')
          .format('YYYY-MM-DD');
      fareItem.returnDate =
        fareItem.returnDate &&
        dayjs(fareItem.returnDate)
          .subtract(uiDatesYearsAdjustmentPatch * -1, 'year')
          .format('YYYY-MM-DD');
      fareItem.formattedDepartureDate = formatDate(
        fareItem.formattedDepartureDate,
        fareItem.departureDate
      );
      fareItem.formattedReturnDate = formatDate(fareItem.formattedReturnDate, fareItem.returnDate);
    } else {
      fareItem.departureDate =
        fareItem.departureDate &&
        dayjs(fareItem.departureDate).add(uiDatesYearsAdjustmentPatch, 'year').format('YYYY-MM-DD');
      fareItem.returnDate =
        fareItem.returnDate &&
        dayjs(fareItem.returnDate).add(uiDatesYearsAdjustmentPatch, 'year').format('YYYY-MM-DD');
      fareItem.formattedDepartureDate = formatDate(
        fareItem.formattedDepartureDate,
        fareItem.departureDate
      );
      fareItem.formattedReturnDate = formatDate(fareItem.formattedReturnDate, fareItem.returnDate);
    }
  }
}
